(() => {
  // === DEINE FESTEN IDS ===
  const KISTE_VARIANT_ID = 55810290385222;
  const TRIGGER_VARIANTS = [55810042134854, 55810047410502, 54919843578182, 54919879786822, 54919880114502, 54919880343878, 54919881294150,56477828776262,56477843095878,56477926195526,56477926228294,56478165795142,56478165827910];
  const KISTE_QTY = 1;
  // =======================

  let busy = false;

  async function getCart() {
    const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return r.json();
  }

  function cartHasTrigger(cart) {
    return cart.items.some((i) => TRIGGER_VARIANTS.includes(i.variant_id));
  }

  function findKiste(cart) {
    return cart.items.find((i) => i.variant_id === KISTE_VARIANT_ID);
  }

  async function changeKiste(quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: KISTE_VARIANT_ID, quantity }),
    });
  }

  async function addKisteOnceIfNeeded() {
    if (busy) return;
    busy = true;
    try {
      const cart = await getCart();
      const trigger = cartHasTrigger(cart);
      const kiste = findKiste(cart);

      if (trigger) {
        if (!kiste) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: KISTE_VARIANT_ID, quantity: KISTE_QTY }] }),
          });
        } else if (kiste.quantity !== KISTE_QTY) {
          await changeKiste(KISTE_QTY); // exakt 1
        }
      } else {
        if (kiste) await changeKiste(0); // weg wenn keine Trigger-Fliese mehr
      }
    } catch (e) {
      console.warn("Kisten-Fix Fehler:", e);
    } finally {
      busy = false;
    }
  }

  // === 1) EXPRESS CHECKOUT AUSBLENDEN, WENN TRIGGER-VARIANTE GEWÄHLT ===
  // Das verhindert, dass Kunden “direkt” in den Checkout springen ohne Kisten-Logik.
  function hideExpressIfTriggerSelected() {
    const variantInput = document.querySelector('input[name="id"]');
    const payBlock = document.querySelector(".shopify-payment-button");
    if (!variantInput || !payBlock) return;

    const v = parseInt(variantInput.value);
    payBlock.style.display = TRIGGER_VARIANTS.includes(v) ? "none" : "";
  }

  // === 2) ROBUST: ALLE /cart/add.js AUFRUFE ABFANGEN (auch Mobile/QuickAdd) ===
  const _fetch = window.fetch;
  window.fetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : (input && input.url) || "";

    // Nur cart/add abfangen
    const isAdd = url.includes("/cart/add");
    if (!isAdd) return _fetch(input, init);

    try {
      // Body kann JSON oder FormData sein
      let addedVariantId = null;

      if (init.body && typeof init.body === "string") {
        // JSON-string
        const data = JSON.parse(init.body);
        if (data && data.id) addedVariantId = parseInt(data.id);
        if (data && data.items && data.items[0] && data.items[0].id) {
          addedVariantId = parseInt(data.items[0].id);
        }
      } else if (init.body instanceof FormData) {
        const id = init.body.get("id");
        if (id) addedVariantId = parseInt(id);
      }

      // Erst normal adden
      const res = await _fetch(input, init);

      // Wenn Trigger-Variante hinzugefügt wurde: Kiste sicherstellen
      if (addedVariantId && TRIGGER_VARIANTS.includes(addedVariantId)) {
        // warten bis Shopify das Item im Cart hat, dann Kiste ergänzen
        setTimeout(addKisteOnceIfNeeded, 200);
      }

      return res;
    } catch (e) {
      // Fallback: normaler fetch
      return _fetch(input, init);
    }
  };

  // === 3) CART-PAGE: Kiste “nicht löschbar” machen (dein Theme nutzt <tr class="cart-item">) ===
  function lockKisteRemoveUI() {
    document.querySelectorAll(".cart-item").forEach((row) => {
      const vid = parseInt(row.getAttribute("data-variant-id") || "");
      if (vid !== KISTE_VARIANT_ID) return;

      // Entfernen sperren
      const removeLink = row.querySelector("cart-remove-button a");
      if (removeLink) {
        removeLink.style.pointerEvents = "none";
        removeLink.style.opacity = "0.4";
        removeLink.setAttribute("aria-disabled", "true");
        removeLink.setAttribute("tabindex", "-1");
        removeLink.title = "Holzkiste ist Pflicht für Großformat";
      }

      // Mengenfeld sperren (damit nicht 0)
      const qtyInput = row.querySelector('input[name="updates[]"]');
      if (qtyInput) {
        qtyInput.setAttribute("readonly", "readonly");
        qtyInput.setAttribute("aria-readonly", "true");
      }
    });
  }

  async function refreshAll() {
    hideExpressIfTriggerSelected();
    await addKisteOnceIfNeeded();
    lockKisteRemoveUI();
  }

  document.addEventListener("DOMContentLoaded", () => {
    refreshAll();
    // Wenn Variante gewechselt wird
    document.addEventListener("change", () => setTimeout(refreshAll, 150), { passive: true });
    document.addEventListener("click", () => setTimeout(refreshAll, 250), { passive: true });
  });
})();
